import resolve from 'contentful-resolve-response';
import fetch from 'isomorphic-fetch';
import { ACCESS_TOKEN, CONTENTFUL_BASE_URL, SPACE_ID } from './constants';

function resolveResponse(res = null) {
  if (res && !res.resolved) {
    return resolve(res);
  }
  return res;
}

function resolveSingleEntry(res = null) {
  const resolvedResponse = resolveResponse(res);
  return Array.isArray(resolvedResponse)
    ? resolvedResponse[0]
    : resolvedResponse;
}

async function getContentfulData(type) {
  const url = `${CONTENTFUL_BASE_URL}/spaces/${SPACE_ID}/entries/?access_token=${ACCESS_TOKEN}&content_type=${type}&include=5`;
  // Contentful injoignable (offline, bloqueur de contenu, panne) : les
  // encarts sont décoratifs — on rend leur fallback (null) plutôt que de
  // laisser fuir une rejection non catchée depuis les useEffect appelants
  // (overlay plein écran en dev, bruit Sentry en prod).
  try {
    const res = await fetch(url);
    return await res.json();
  } catch {
    return null;
  }
}

export { resolveResponse, resolveSingleEntry, getContentfulData };
